import './productListing.scss';


import React from 'react';
import manualIcon from '../../images/icons/icon-Manuels-Page-Icon-1.svg';
import partIcon from '../../images/icons/icon-Pieces-Icon-2.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../primitives';

type PartsListingProps = {
    columns: any[];
    products: any[];
};

export default function PartsListing(props: PartsListingProps) {
    const { columns, products } = props;
    const { t } = useTranslation('templatePages');
    const { currentLocale } = usePageLocalization();

    return (
        <div className={`productListing col-${columns}`}>
            <div className='container'>
                {products.length === 0 ? (
                    <strong className='resultNumber'>{t('no-result')}</strong>
                ) : (
                    <>
                        <strong className='resultNumber'>
                            {products.length} {t('results')}
                        </strong>

                        <table className='partsTable'>
                            <thead className='borderedHead'>
                                <tr>
                                    <th>{t('product-name')}</th>
                                    <th>{t('product-number')}</th>
                                    <th>{t('product-serial')}</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.map((product, index) => {
                                    const serialNumberFrom =
                                        product.attributes?.serial_number_from
                                            ?.values[0]['en_CA'];
                                    const serialNumberTo =
                                        product.attributes?.serial_number_to
                                            ?.values[0]['en_CA'];

                                    return (
                                        <tr
                                            className='productInfos'
                                            key={index}
                                        >
                                            <td>
                                                {product.title[currentLocale]}
                                            </td>
                                            <td>{product.code}</td>
                                            <td>
                                                {serialNumberFrom &&
                                                serialNumberTo
                                                    ? t('serial-fromto', {
                                                          from: serialNumberFrom,
                                                          to: serialNumberTo,
                                                      })
                                                    : serialNumberFrom ===
                                                      undefined
                                                    ? '--'
                                                    : t('serial-from', {
                                                          from: serialNumberFrom,
                                                      })}
                                            </td>
                                            <td className='actions'>
                                                {product.parts && (
                                                    <LocalizedLink
                                                        to={`/archives/${product.code.toLowerCase()}/parts/`}
                                                    >
                                                        <img
                                                            width={30}
                                                            src={partIcon}
                                                            alt={partIcon}
                                                            title={t(
                                                                'part-tooltip'
                                                            )}
                                                        />
                                                    </LocalizedLink>
                                                )}

                                                {product.documents && (
                                                    <LocalizedLink
                                                        to={`/archives/${product.code.toLowerCase()}/manuals/`}
                                                    >
                                                        <img
                                                            width={30}
                                                            src={manualIcon}
                                                            alt={manualIcon}
                                                            title={t(
                                                                'manual-tooltip'
                                                            )}
                                                        />
                                                    </LocalizedLink>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </div>
    );
}
